const isValidAppPath = (path: string): boolean => {
  return path.startsWith('/') && !path.startsWith('//');
};

export const getSafeReturnToPath = (
  returnTo: string | null | undefined,
  fallbackPath: string,
): string => {
  if (!returnTo) return fallbackPath;

  try {
    const url = new URL(returnTo, window.location.origin);
    const candidate = `${url.pathname}${url.search}${url.hash}`;
    return isValidAppPath(candidate) ? candidate : fallbackPath;
  } catch {
    return fallbackPath;
  }
};
